import { z } from 'zod';

import { BaseToolResultSchema } from './baseResult';

export const BRAND_KIT_SETUP_TOOL_NAME = 'elicit_brand_kit_setup' as const;

export const BrandKitSetupActionSchema = z.object({
  label: z.string(),
  type: z.enum(['create', 'cancel']),
});

export type BrandKitSetupAction = z.infer<typeof BrandKitSetupActionSchema>;

export const BrandKitSetupResultSchema = BaseToolResultSchema.extend({
  actions: z.array(BrandKitSetupActionSchema).min(1),
  existingContextSourceId: z.string().optional(),
  mode: z.enum(['confirm_create', 'confirm_regenerate', 'request_domain']),
  placeholder: z.string().optional(),
  sourceDomain: z.string().optional(),
  type: z.literal('brand_kit_setup'),
  updateWorkspaceThumbnail: z.boolean().optional(),
});

export type BrandKitSetupResult = z.infer<typeof BrandKitSetupResultSchema>;
